import React, { Component } from "react";
import { func, node, bool } from "prop-types";
import { useTranslation, withTranslation } from "@lib/i18n";

import ClearStorageModal from "../ClearStorageModal/ClearStorageModal";

const DefaultFallback = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center size-full">
      <h1>{t("errors.currentlyUnavailable")}</h1>
    </div>
  );
};

// @see https://reactjs.org/docs/error-boundaries.html
class ErrorBoundary extends Component {
  static propTypes = {
    children: node.isRequired,
    t: func.isRequired,
    fallback: node,
    withModal: bool,
    fallbackFunction: func,
  };

  static defaultProps = {
    fallback: <DefaultFallback />,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      isModalOpen: false,
    };
  }

  componentDidCatch() {
    this.setState({ isModalOpen: true });
  }

  componentDidMount() {
    if (this.state.hasError && this.props.fallbackFunction) {
      this.props.fallbackFunction();
    }
  }

  render() {
    const { hasError, isModalOpen } = this.state;
    const { fallback, children, t, withModal = true } = this.props;

    if (hasError) {
      return (
        <>
          {withModal && (
            <ClearStorageModal
              hideCancelButton
              isOpen={isModalOpen}
              title={t("errorBoundary.modalTitle")}
              message={t("errorBoundary.clearStorageMessage")}
            />
          )}
          {fallback}
        </>
      );
    }

    return children;
  }
}

export default withTranslation()(ErrorBoundary);
